<template>
  <ODialog
    ref="dialog"
    :title="$t('alerts.delete.title')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', variant: 'danger', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Alert } from '~/_api/models/alert'

interface Props {
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification, $bus } = useNuxtApp()

const dialog = ref()
const alert = ref<Alert | null>(null)

const open = (item: Alert) => {
  alert.value = item
  dialog.value.open()
}

const confirm = async () => {
  if (!alert.value) return

  emit('update:loading', true)

  try {
    const response = await $api.alert.delete(alert.value)
    emit('update:loading', false)

    if (response.success) {
      $notification.toast({
        title: $i18n.t('alerts.delete.success'),
        variant: 'success',
      })

      emit('success')

      $bus.emit.updated('Alert', alert.value)

      return true
    }
  } catch (e: any) {
    emit('update:loading', false)
    console.log(e)

    $notification.toast({ errors: e?.errors })

    emit('error')
  }
}

defineExpose({
  open,
})
</script>
